import React, {useState} from 'react';
import {
  reduxAddCreateProgramLine,
  reduxToggleSidePanel,
  reduxUpdateCreateProgramLine,
} from 'appredux/actions';
import {
  IFarmInputProduct,
  IFarmInputProgramLineInput,
  ISupplierUserProfile,
} from 'constants/interfaces';

import {ProgramLineForm} from 'components/ProgramForm/ProgramLineForm';
import {
  PROGRAM_APPLICATION_TYPE,
  PROGRAM_APPLICATION_UNIT,
  PROGRAM_STAGES,
} from 'constants/index';

export default function AddOrUpdateProgramLine(props: {
  user: ISupplierUserProfile;
  programLine?: IFarmInputProgramLineInput;
  index?: number;
  allProducts: IFarmInputProduct[];
}) {
  const [programLine] = useState<IFarmInputProgramLineInput | undefined>(
    props.programLine,
  );
  const [isLoading] = useState(false);

  const isAdding = !props.programLine && props.index === undefined;
  const isCopying = !!props.programLine && props.index === undefined;

  const onSubmitProgramLine = (submission: IFarmInputProgramLineInput) => {
    if (isAdding) reduxAddCreateProgramLine(submission);
    else if (isCopying) reduxAddCreateProgramLine(submission);
    else reduxUpdateCreateProgramLine(submission, props.index!);
    reduxToggleSidePanel(false, null);
    return;
  };

  const activeProducts = props.allProducts.filter(
    (product) => product.isActive,
  );

  return (
    <ProgramLineForm
      programLine={programLine}
      isLoading={isLoading}
      isLoadingStages={false}
      stages={PROGRAM_STAGES}
      isLoadingProducts={false}
      allProducts={activeProducts}
      isLoadingApplicationUnits={false}
      applicationUnits={PROGRAM_APPLICATION_UNIT}
      isLoadingApplicationTypes={false}
      applicationTypes={PROGRAM_APPLICATION_TYPE}
      submitButtonTitle={isAdding || isCopying ? 'Add' : 'Update'}
      onSubmit={onSubmitProgramLine}
      cancelButtonTitle={'Cancel'}
      onCancel={() => reduxToggleSidePanel(false)}
      readonly={false}
    />
  );
}
